import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({ selector: '[sideBar]' })
export class SideBarDirective {

    timer: any = null;

    constructor(private el: ElementRef, private renderer: Renderer2) {
        // Access the native element using ElementRef.nativeElement
        console.log(this.el.nativeElement);
    }
    @HostListener('mouseenter') onMouseEnter() {
        this.timer = setTimeout(() => {
            this.renderer.addClass(this.el.nativeElement, 'sidebar-container-hover');
        }, 500)
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        clearTimeout(this.timer);
        this.renderer.removeClass(this.el.nativeElement, 'sidebar-container-hover');
    }


}